/**
 * Locale codes with translation bundles, mirroring the `supportedLocales`
 * list in df-generate.config.json (minus the plain `en` fallback bundle,
 * which is not a country locale). Canonical source for QA user generation
 * and URL locale validation — do not duplicate this list.
 */
export const SUPPORTED_LOCALES = [
  'de_de',
  'en_de',
  'en_xx',
  'fr_fr',
  'en_fr',
  'pt_br',
  'en_br',
  'de_at',
  'en_at',
  'pl_pl',
  'en_pl',
  'nl_nl',
  'en_nl',
  'uk_ua',
  'en_ua',
  'en_ca',
  'en_us',
  'es_ar',
  'en_ar',
  'en_be',
  'fr_be',
  'nl_be',
  'en_gb',
  'en_hu',
  'hu_hu',
  'en_cz',
  'cs_cz',
  'en_jp',
  'ja_jp',
  'en_ru',
  'ru_ru',
  'en_it',
  'it_it',
  'en_lt',
  'lt_lt',
  'en_in',
  'hi_in',
  'te_in',
  'pa_in',
  'en_ie',
  'en_ro',
  'ro_ro',
  'en_es',
  'es_es',
  'en_tr',
  'tr_tr',
] as const;

/**
 * Extract country code from a locale string.
 * "en_de" → "de", "de_de" → "de", "en" → "en"
 */
export const getCountryFromLocale = (locale: string): string => {
  if (!locale.includes('_')) return locale;
  return locale.split('_')[1];
};

export const getLanguageFromLocale = (locale: string): string => {
  const [language] = locale.toLowerCase().split(/[_-]/);
  return language ?? '';
};
